import { authHeader } from '../_helpers';
import dotenv from 'dotenv';
// import config from '../config/config.json';
dotenv.config();

export const userService = {
  login,
  logout,
  getAll,
  forgetPassword,
  changePassword
};

function login(username, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: username, password: password })
  };
  // config.BASE_URL + `/v10/user/login`
  // `/users/authenticate`
  return fetch(
    process.env.REACT_APP_BASE_URL + `/v10/user/login`,
    // `/v10/user/login`,
    // config.BASE_URL + `/v10/user/login`,
    // 'https://us-central1-taxigy-bfe19.cloudfunctions.net/api/v10/user/login',
    requestOptions
  )
    .then(handleResponse)
    .then(user => {
      let { results } = user;
      console.log('user data', results);
      // login successful if there's a jwt token in the response
      if (results[0].token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(results[0]));
      }

      return user;
    })
    .catch(err => {
      console.log('erro user', err);
      return err;
    });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user');
}

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        // location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function forgetPassword(email) {
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(email)
  };
  return fetch(
    process.env.REACT_APP_BASE_URL + `/v10/user/update-pass`,
    requestOptions
  )
    .then(handleResponse)
    .then(user => {
      return user;
    })
    .catch(err => {
      return err;
    });
}

function changePassword(key) {
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ key: key })
  };
  return fetch(
    process.env.REACT_APP_BASE_URL + `/v10/user/forgot-password`,
    requestOptions
  )
    .then(handleResponse)
    .then(user => {
      return user;
    })
    .catch(err => {
      return err;
    });
}
